/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const InfoCircle = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 31.25 31.25" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g><path d="M15.49 7.41a2 2 0 1 0 2 2 2 2 0 0 0-2-2zM13.7 13.78v9.81h3.58v-9.81H13.7z" /><path d="M15.5 2A13.5 13.5 0 1 1 2 15.5 13.52 13.52 0 0 1 15.5 2m0-2A15.5 15.5 0 1 0 31 15.5 15.5 15.5 0 0 0 15.5 0z" /></g>
      </g>
    </svg>
  </span>
);

InfoCircle.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

InfoCircle.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default InfoCircle;
